import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useParametricSelector } from 'src/hooks/useParametricSelector';
import { DocumentLayout } from 'src/modules/common/layouts/DocumentLayout';
import { getLanguage } from 'src/modules/config/selectors/getLanguage';
import { getHvacResults } from 'src/modules/hvac/selectors/getHvacResults';
import { getLoggedInUser } from 'src/modules/login/selectors/getLoggedInUser';
import { OutputDocument } from 'src/modules/output/views/OutputDocument';
import { getProjectDetails } from 'src/modules/project-view/selectors/getProjectDetails';
import { getReportEmbeddings } from 'src/modules/report/selectors/getReportEmbeddings';
import { getReportFormData } from 'src/modules/report/selectors/getReportFormData';
import { getReportGenerated } from 'src/modules/report/selectors/getReportGenerated';
import { ReportDocumentContent } from 'src/modules/report/views/ReportDocumentContent';

export const ReportDocumentPage = (): React.ReactElement => {
  const intl = useIntl();
  const project = useSelector(getProjectDetails);
  const language = useSelector(getLanguage);
  const document = useParametricSelector(getReportGenerated, project);
  const formData = useParametricSelector(getReportFormData, project);
  const embeddings = useSelector(getReportEmbeddings);
  const loggedInUser = useSelector(getLoggedInUser);
  const results = useParametricSelector(getHvacResults, project);

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({ id: 'report/pageTitle' })}
        </title>
      </Helmet>
      <DocumentLayout>
        <OutputDocument embeddings={formData.appendix.enabled ? embeddings : {}}>
          <ReportDocumentContent
            results={results}
            document={document}
            formData={formData}
            project={project}
            language={language}
            embeddings={embeddings}
            userSettings={loggedInUser.settings}
          />
        </OutputDocument>
      </DocumentLayout>
    </>
  );
};
